var React = require('react');

function IcFilterList (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0V2H18V0H0ZM7 12H11V10H7V12ZM15 7H3V5H15V7Z","fill":"currentColor"}));
}

IcFilterList.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = IcFilterList;

IcFilterList.default = IcFilterList;
